module.exports = __webpack_public_path__ + "img/pitcher_white_icon.89821fd8.png";